import React, { useState, useEffect } from 'react';
import './select.css';
import lupa from '../../icons/icon_lupa.svg';

interface SelectOption {
    value: string;
    text: string;
    image?: string;
    [key: string]: any;
}

interface SelectProps {
    search?: boolean;
    required?: string;
    autofocus?: boolean;
    onBlur?: ((e: React.FocusEvent<HTMLInputElement>) => void) | null;
    placeholder?: string;
    name?: string;
    id?: string;
    value?: string;
    options?: SelectOption[];
    onChange?: ((value: string, input: string) => void) | null;
    handleChange?: ((value: string, input: string) => void) | null;
}

const SelectOptionEl = ({ el }: { el: SelectOption | string }) => {
    if (typeof el === 'object') {
        return (
            <>
                {[el].map((item) => {
                    let keys = Object.keys(item);
                    return keys.map((key, index) => {
                        if (key === 'image') {
                            return (
                                <span key={index}>
                                    <img
                                        src={item[key]}
                                        alt=""
                                    />
                                </span>
                            );
                        }
                        if (key === 'value') {
                            return (
                                <input
                                    key={index}
                                    type="hidden"
                                    value={item[key]}
                                />
                            );
                        }
                        return <span key={index}>{item[key]}</span>;
                    });
                })}
            </>
        );
    }
    return <></>;
};

const Select: React.FC<SelectProps> = ({
    search = true,
    required = '',
    autofocus = false,
    onBlur = null,
    placeholder = 'Select your option',
    name = '',
    id = '',
    value = '',
    options = [],
    onChange = null,
    handleChange = null,
}) => {
    const [input, setInput] = useState('');
    const [tempInput, setTempInput] = useState('');
    const [tempOptions, setTempOptions] = useState<(SelectOption | string)[]>(options);
    const [selectOpen, setSelectOpen] = useState(false);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (options !== null && options.length > 0 && value !== '') {
            options.forEach((option) => {
                if (option.value === value) {
                    setInput(option.text);
                }
            });
            setTempOptions(options);
            if (options !== null && options.length > 0 && !loaded) {
                setLoaded(true);
                setTempOptions(options);
            }
        }
        // options.length (e nao options) porque o array e recriado a cada render;
        // isso garante o preenchimento do texto quando as options chegam depois do value
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, options.length]);

    useEffect(() => {
        if (input !== '') {
            selectFilter();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [input]);

    const handleChangeSelect = (value: string) => {
        if (typeof handleChange === 'function' && value !== undefined && value !== '') {
            handleChange(value, input);
        }
        if (typeof onChange === 'function' && value !== undefined && value !== '') {
            onChange(value, input);
        }
    };

    const selectFilter = () => {
        if (input === undefined) {
            return;
        }
        if (input.length === 0) {
            setTempOptions(options);
            return;
        }
        let newOptions: (SelectOption | string)[] = [];
        options.forEach((el) => {
            if (el !== undefined) {
                if (typeof el === 'object') {
                    let keys = Object.keys(el);
                    let filter: string[] = [];
                    keys.forEach((key) => {
                        if (key === 'image') {
                            return;
                        }
                        filter.push(key);
                    });
                    let inp = input;
                    filter.forEach((f) => {
                        if (
                            typeof el[f] === 'string' &&
                            (el[f].includes(inp.toLowerCase()) ||
                                el[f].toLowerCase().includes(inp.toLowerCase()) ||
                                el[f].toUpperCase().includes(inp.toLowerCase())) &&
                            !newOptions.includes(el)
                        ) {
                            newOptions.push(el);
                            return;
                        }
                    });
                    return;
                }
                let inp = input;
                const elStr = el as unknown as string;
                if (
                    elStr.includes(inp.toLowerCase()) ||
                    elStr.toLowerCase().includes(inp.toLowerCase()) ||
                    elStr.toUpperCase().includes(inp.toLowerCase())
                ) {
                    newOptions.push(elStr);
                }
            }
        });
        if (newOptions.length === 0) {
            newOptions = [';-('];
        }
        setTempOptions(newOptions);
    };

    const handleInput = (e: React.SyntheticEvent<HTMLInputElement>) => {
        const evt = e as any;
        switch (e.type) {
            case 'focus':
                setSelectOpen(true);
                break;
            case 'click':
                evt.stopPropagation();
                setSelectOpen(!selectOpen);
                setTempOptions(options);
                break;
            case 'change':
            case 'keyup':
                if (search) {
                    setSelectOpen(true);
                    setInput(evt.target.value);
                }
                break;
            case 'blur':
                setSelectOpen(false);
                if (typeof onBlur === 'function') {
                    handleChangeSelect(tempInput);
                    onBlur(e as React.FocusEvent<HTMLInputElement>);
                }
                break;
        }
    };

    const handleOption = (e: React.MouseEvent<HTMLDivElement>) => {
        let target = e.target as HTMLElement;
        if (target.tagName === 'SPAN') {
            target = target.parentNode as HTMLElement;
        }
        if (target.querySelector('input') !== null) {
            let value = target.querySelector('input')!.value;
            if ((e.target as HTMLElement).innerText !== ';-(') {
                setSelectOpen(false);
                setInput((e.target as HTMLElement).innerText);
                handleChangeSelect(value);
            }
        }
    };

    if (options === null || (options !== null && options.length === 0)) {
        return <></>;
    }

    return (
        <label
            className={'agendamento-input select-component ' + (selectOpen ? 'select-dropdown-open' : '')}
            htmlFor={id}
        >
            <img
                src={lupa}
                alt="icone-lupa"
            />
            <input
                name={name}
                type="hidden"
                value={value || ''}
            />
            <input
                autoFocus={autofocus}
                onClick={handleInput}
                onChange={handleInput}
                onKeyUp={handleInput}
                onBlur={handleInput}
                data-required={required}
                type="text"
                value={input || ''}
                placeholder={placeholder}
            />
            <div className="select-dropdown">
                {tempOptions !== null ? (
                    tempOptions.map((el, key) => {
                        return (
                            <div
                                onMouseEnter={() => setTempInput((el as SelectOption).value)}
                                onClick={handleOption}
                                key={key}
                            >
                                <SelectOptionEl el={el} />
                            </div>
                        );
                    })
                ) : (
                    <></>
                )}
                {/*<div style={{height: "30px"}}></div>*/}
            </div>
        </label>
    );
};

export default Select;
